import classes from "./GoogleButton.module.scss";
import Image from "next/image";
import Google from "../../../assets/images/registration/google-icon.svg";
import {useTranslation} from "react-i18next";
import {useRouter} from "next/navigation";

const GoogleButton = ({className}) => {
    const {t} = useTranslation();
    const router = useRouter();

    const googleRedirect = () => {
        let url;
        fetch(`${process.env.NEXT_PUBLIC_API_URL}/login/google`)
            .then((response) => response.json())
            .then((data) => {
                url = data.url
                router.push(data.url)
            }).catch((error) => {
            router.push('/login')
        })
    }

    return (
        <div onClick={googleRedirect} className={`${classes.googleButton} 
        ${className && className}`}>
            <span>
                <Image src={Google} alt="google-icon"/>
            </span>
            <button>{t('buttons.signInWith')} Google</button>
        </div>
    );
}

export default GoogleButton;